import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { BreadCrumbActions } from '../../../shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { startWith, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../configuration-option.selectors'
import { configurationOptionActions } from '../configuration-option.actions'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { getBreadCrumb } from 'src/app/shared/components/breadcrumb/breadcrumb.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
@UntilDestroy()
@Component({
  selector: 'configuration-option-overview-field-and-tags',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionOverviewFieldAndTagsComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public activeTab: string = 'general.branding'
  public routerlink: string = 'branding'
  public arrayTabMenuObjects: any[] = []
  public moduleConfigs: any
  public isMultiDayEnabled = environment.moduleConfigs?.saleModule?.isActive
    ? environment.moduleConfigs?.saleModule?.multiDayFlow
    : false

  public accessRights = AccessRights
  public operationInternalShow: boolean
  public locationShow: boolean

  constructor(
    private store: Store<AppState>,
    private router: Router,
    public accessRightService: UserAccessRightService
  ) {}

  ngOnInit() {
    this.store.dispatch(configurationOptionActions.initActions())
    this.moduleConfigs = environment.moduleConfigs

    this.isLoading$ = this.store
      .select(configurationOptionSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.accessRightService
      .isAllowedByAccessRight([this.accessRights.OperationInternalEvents_read])
      .pipe(take(1))
      .subscribe((isAllowed) => {
        this.operationInternalShow = isAllowed
          ? this.moduleConfigs.surveyModule.isActive
          : false
      })
    this.accessRightService
      .isAllowedByAccessRight([this.accessRights.Locations_read])
      .pipe(take(1))
      .subscribe((isAllowed) => {
        this.locationShow = isAllowed
          ? this.moduleConfigs.locationModule.isActive
          : false
      })
    this.store
      .select(getBreadCrumb)
      .pipe(untilDestroyed(this))
      .subscribe((breadCrumb) => {
        if (breadCrumb.length == 1) {
          this.router.navigateByUrl(
            'configuration-options/filter-tags/filter-tag'
          )
        }
      })
    this.arrayTabMenuObjects = [
      {
        name: 'filter-tag',
        jsonTranslation: 'configurationOptionModule.filterTags',
        show: true,
        iconName: 'tags'
      },

      {
        name: 'registration',
        jsonTranslation: 'general.registrationMember',
        show: true,
        iconName: 'key'
      },
      {
        name: 'revalidate-form',
        jsonTranslation: 'memberModule.revalidateForm',
        show: this.moduleConfigs.configOptionModule.showRevalidateFormTab,
        iconName: 'id-card'
      },
      {
        name: 'organization',
        jsonTranslation: 'organizationModule.organization',
        show: this.moduleConfigs.organizationModule.isActive,
        iconName: 'house-user'
      },
      {
        name: 'profile',
        jsonTranslation: 'general.profile',
        show: true,
        iconName: 'user'
      },
      {
        name: 'tags',
        jsonTranslation: 'tagModule.tags',
        show: true,
        iconName: 'tag'
      },

      {
        name: 'categories',
        jsonTranslation: 'general.categoriesDesc',
        show: true,
        iconName: 'align-center'
      }
    ]
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'general.settings',
        url: '/configuration-options/filter-tags/filter-tag',
        titleName: ['configurationOptionModule.fieldsAndTags', this.activeTab]
      })
    )
  }

  setActiveTab(tab) {
    this.activeTab = tab
    this.routerlink = tab.split('.').pop()

    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: tab,
        url: this.router.url,
        titleName: ['configurationOptionModule.fieldsAndTags', this.activeTab]
      })
    )
    this.store.dispatch(
      BreadCrumbActions.filterBreadCrumb({
        pageName: tab,
        url: this.router.url,
        titleName: ['configurationOptionModule.fieldsAndTags']
      })
    )
  }
}
